export const environment = {
  production: true,
  i18nPath: '/repository/assets/i18n/',
  apiUrl:"https://test.adesuite.com/repository-services",
  bucket:"tz-repository"
};
